<nb-card class="incoming-call-card">
  <nb-card-header>
    <div class="dialog-header">
      <nb-icon icon="phone-call-outline" class="incoming-icon"></nb-icon>
      <span>Incoming Support Call</span>
    </div>
  </nb-card-header>

  <nb-card-body>
    <div class="caller-info">
      <div class="caller-avatar">
        <nb-icon icon="person-outline"></nb-icon>
      </div>
      <div class="caller-details">
        <p class="caller-name">{{ callerName || 'Unknown Caller' }}</p>
        <p class="caller-role">{{ callerRole | titlecase }}</p>
      </div>
    </div>
    <p class="call-message">
      <strong>{{ callerName || 'Someone' }}</strong> ({{ callerRole }}) is calling you for support.
    </p>
  </nb-card-body>

  <nb-card-footer>
    <div class="dialog-actions">
      <button nbButton status="success" (click)="accept()">
        <nb-icon icon="phone-outline"></nb-icon>
        Accept
      </button>
      <button nbButton status="danger" (click)="reject()">
        <nb-icon icon="phone-missed-outline"></nb-icon>
        Decline
      </button>
    </div>
  </nb-card-footer>
</nb-card>
